import THEMES from "./brands.generated.json";

export interface BrandEntry {
  name: string;
  tagline: string;
  logoUrl: string;
  logoWidth?: number;
  logoHeight?: number;
  wordmarkBold?: string;
  wordmarkRest: string;
}

export interface Brand extends BrandEntry {
  displayName: string;
}

type Registry = { default: BrandEntry } & Record<string, BrandEntry | undefined>;

function assertRegistry(raw: unknown): asserts raw is Registry {
  const reg = raw as Record<string, Partial<BrandEntry> | undefined>;
  if (!reg.default) {
    throw new Error("brands.json must define a 'default' brand");
  }
  for (const key of Object.keys(reg)) {
    const entry = reg[key];
    if (
      !entry ||
      typeof entry.name !== "string" ||
      typeof entry.tagline !== "string" ||
      typeof entry.logoUrl !== "string" ||
      typeof entry.wordmarkRest !== "string"
    ) {
      throw new Error(
        `brands.json entry "${key}" is missing required fields (name, tagline, logoUrl, wordmarkRest)`
      );
    }
  }
}

assertRegistry(THEMES);
const registry: Registry = THEMES;

export function resolveBrand(themeName?: string): Brand {
  const entry =
    themeName && registry[themeName] ? registry[themeName]! : registry.default;
  const merged: BrandEntry = { ...registry.default, ...entry };
  const wordmarkBold = merged.wordmarkBold ?? "";
  return {
    ...merged,
    wordmarkBold,
    displayName: `${wordmarkBold}${merged.wordmarkRest}`,
  };
}

export const brand: Brand = resolveBrand(process.env.REACT_APP_THEME);
